<template>
  <ul
    data-testid="menu-option-list"
    class="rounded-sm border bg-surface-level-1 text-base/6 shadow-lg focus:outline-hidden sm:text-sm/5">
    <slot />
  </ul>
</template>

<script setup lang="ts"></script>
